import { useEffect, useState } from "react";
import { BellRing, BellOff, Loader2 } from "lucide-react";
import { enablePush, disablePush, getCurrentSubscription, pushPermission, pushSupported } from "@/lib/push";
import { api } from "@/lib/api";

// Card per attivare le notifiche push sullo smartphone
export const PushToggle = () => {
  const [active, setActive] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    getCurrentSubscription().then((s) => setActive(!!s && pushPermission() === "granted")).catch(() => {});
  }, []);

  const toggle = async () => {
    setBusy(true); setMsg(null);
    try {
      if (active) { await disablePush(); setActive(false); setMsg("Notifiche disattivate su questo dispositivo."); }
      else {
        await enablePush(); setActive(true);
        await api.post("/push/test").catch(() => {});
        setMsg("✓ Notifiche attive! Ti abbiamo inviato una notifica di prova.");
      }
    } catch (e) { setMsg(e.message || "Impossibile attivare le notifiche"); }
    finally { setBusy(false); }
  };

  if (!pushSupported()) {
    return (
      <div className="paper-card p-4 mb-6 text-sm text-labor-muted" data-testid="push-unsupported">
        Questo browser non supporta le notifiche push. Installa l'app CAF Labor dal Play Store per ricevere promemoria e Newsletter.
      </div>
    );
  }
  return (
    <div className={`paper-card p-5 mb-6 border-l-4 flex items-start gap-4 flex-wrap ${active ? "border-l-labor-italianGreen" : "border-l-labor-terracotta bg-labor-skyBg"}`} data-testid="push-toggle-card">
      {active ? <BellRing className="w-7 h-7 text-labor-italianGreen flex-shrink-0" /> : <BellOff className="w-7 h-7 text-labor-terracotta flex-shrink-0" />}
      <div className="flex-1 min-w-[200px]">
        <div className="font-display text-lg">{active ? "Notifiche push attive" : "Attiva le notifiche sul telefono"}</div>
        <div className="text-sm text-labor-muted mt-0.5">
          Promemoria appuntamenti (il giorno prima e 2 ore prima), posti liberati dalla lista d'attesa e Newsletter CAF Labor.
        </div>
        {msg && <div className="text-xs mt-2 text-labor-ink" data-testid="push-toggle-msg">{msg}</div>}
      </div>
      <button data-testid="push-toggle-btn" onClick={toggle} disabled={busy}
        className={`${active ? "border border-labor-border hover:bg-labor-bg" : "olive-btn"} px-5 py-2.5 text-sm font-semibold flex items-center gap-2`}>
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} {active ? "Disattiva" : "Attiva notifiche"}
      </button>
    </div>
  );
};
